import './QuizPage.css';

function ProgressBar({ progress, remainingSeconds }) {
  const isUrgent = remainingSeconds <= 10;

  return (
    <div className="progress-section">
      <div className="progress-meta">
        <span className="progress-label">剩余时间</span>
        <span className={`progress-time ${isUrgent ? 'urgent' : ''}`}>
          {remainingSeconds}s
        </span>
      </div>
      <div className="progress-track">
        <div
          className={`progress-fill ${isUrgent ? 'urgent' : ''}`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}

function OptionItem({ option, selected, isMultiple, onToggle }) {
  return (
    <button
      type="button"
      className={`option-item ${selected ? 'selected' : ''}`}
      onClick={() => onToggle(option.选项编号)}
    >
      <span className="option-id">{option.选项编号}</span>
      <span className="option-content">{option.选项内容}</span>
      <span className={`option-check ${isMultiple ? 'checkbox' : 'radio'}`}>
        {selected && (isMultiple ? '✓' : '●')}
      </span>
    </button>
  );
}

export default function QuizPage({
  question,
  selectedAnswers,
  onToggleAnswer,
  onNext,
  submitting,
  // progress,
  // remainingSeconds,
}) {
  const isMultiple = question.题类型 === '多选';

  return (
    <div className="quiz-page">
      <header className="quiz-header">
        <div className="question-counter">
          第 {question.当前是第几题} 题 / 共 {question.总共有多少题} 题
        </div>
        {/* 暂时注释掉时间限制 */}
        {/* <ProgressBar progress={progress} remainingSeconds={remainingSeconds} /> */}
      </header>
      <main className="quiz-body">
        <div className="question-type-badge">
          {isMultiple ? '多选题' : '单选题'}
        </div>
        <h1 className="question-title">{question.标题}</h1>

        <div className="option-list">
          {question.答案选项.map((option) => (
            <OptionItem
              key={option.选项编号}
              option={option}
              selected={selectedAnswers.includes(option.选项编号)}
              isMultiple={isMultiple}
              onToggle={onToggleAnswer}
            />
          ))}
        </div>
      </main>

      <footer className="quiz-footer">
        <button
          type="button"
          className="next-btn"
          onClick={onNext}
          disabled={submitting}
        >
          {submitting ? '加载中…' : '下一题'}
        </button>
      </footer>
    </div>
  );
}

export { ProgressBar, OptionItem };
